import { render, staticRenderFns } from "./NavbarMenu.vue?vue&type=template&id=2a24ec6b"
import script from "./NavbarMenu.vue?vue&type=script&lang=js"
export * from "./NavbarMenu.vue?vue&type=script&lang=js"
import style0 from "./NavbarMenu.vue?vue&type=style&index=0&id=2a24ec6b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports